import { USER_ACCOUNT_FIELD_IDS } from '../constants';
import { getFormField } from '../utils';
import { removeFieldValidation } from './utils';

const APPLICABLE_COUNTRIES = ['US'];

const zipValidation = (field, bookingForm) => {
    const billingCountry = getFormField(bookingForm, USER_ACCOUNT_FIELD_IDS.country).value || '';
    const shouldValidate = APPLICABLE_COUNTRIES.includes(billingCountry.toUpperCase());
    const fieldValue = field?.value?.toString().replace(/\D/g, '') || '';
    const validZip = fieldValue.length === 5;

    if (!shouldValidate || validZip) {
        // removes any previous errorMap and lets Tix decide whether it's valid
        return removeFieldValidation(field);
    }

    return {
        isFieldValid: false,
        validatedField: {
            errorMap: {
                errorKey: 'zipcode-validation-error',
            },
            id: field.id,
            isValid: false,
        },
    };
};

export default zipValidation;
